import { render, staticRenderFns } from "./AddPickUpGroup.vue?vue&type=template&id=c048b1ec&"
import script from "./AddPickUpGroup.vue?vue&type=script&lang=js&"
export * from "./AddPickUpGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports